var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as SavvyResultsUI from "../../../components/SavvyResultsUI/SavvyResultsUI";
import { AllIssuers } from "@trellisconnect/types/dist/src/enums/AllIssuers";
import { ResultType } from "../../../services/savvy/constants";
import { findSavvyAdvertiser } from "../../../utils/findSavvyAdvertiser";
import { otherIssuer } from "../../../lib/constants";
import useAffiliateConfig from "../../../hooks/useAffiliateConfig";
import useFindIssuer from "../../configuration/useFindIssuer";
function getName(issuerName) {
    if (issuerName.toLowerCase() === AllIssuers.OTHER) {
        return "Current Insurance";
    }
    return issuerName;
}
export default function BundleItem(_a) {
    var _b;
    var result = _a.result, clickText = _a.clickText, index = _a.index, topContent = _a.topContent, bottomContent = _a.bottomContent, insuranceType = _a.insuranceType, rest = __rest(_a, ["result", "clickText", "index", "topContent", "bottomContent", "insuranceType"]);
    var findIssuer = useFindIssuer();
    var _c = useAffiliateConfig(), topOfferBadge = _c.topOfferBadge, hideIssuerLogos = _c.hideIssuerLogos;
    var isCurrentPolicy = result.type === ResultType.CurrentAutoPolicy ||
        result.type === ResultType.CurrentHomePolicy;
    var issuerId = result.issuerId || result.advertiserName;
    var issuer = findIssuer(issuerId || "", { exact: true }) ||
        findSavvyAdvertiser(result.advertiserName || "") || {
        id: issuerId === null || issuerId === void 0 ? void 0 : issuerId.toLocaleLowerCase(),
        name: result.advertiserName || result.issuerName,
    };
    var showFallbackIcon = isCurrentPolicy && hideIssuerLogos && issuerId !== otherIssuer.id;
    return (React.createElement(SavvyResultsUI.Card, { anchorProps: __assign({}, rest), name: getName((_b = (result.issuerName || result.advertiserName)) !== null && _b !== void 0 ? _b : ""), issuerId: issuer.id, badge: isCurrentPolicy ? (React.createElement(SavvyResultsUI.Badge, null, "Current Policy")) : index === 0 && topOfferBadge ? (React.createElement(SavvyResultsUI.Badge, { variant: "green" }, "Top Offer")) : null, clickText: clickText, topContent: topContent, bottomContent: bottomContent, variant: index === 0 ? "highlight" : "default", fallbackIcon: showFallbackIcon, insuranceType: insuranceType }));
}
